import { useMemo } from 'react';
export const useSerialTaskQueue = ()=>{
    const inFlightByKey = useMemo(()=>new Map(), []);
    return (key, task)=>{
        const inFlight = inFlightByKey.get(key);
        const run = inFlight == null ? task() : inFlight.then(task, task);
        inFlightByKey.set(key, run);
        const forget = ()=>{
            if (inFlightByKey.get(key) === run) inFlightByKey.delete(key);
        };
        void run.then(forget, forget);
        return run;
    };
};
